export default (axios, path = '/game/prep/template') => ({
  findAllGameTemplates: async () => {
    return await axios.get(`${path}`)
  },
  saveGameTemplate: async ({id, template}) => {
    var data = template.data
    var jsonData = template.data.jsonData
    var description = template.data.description
    var name = template.data.name
    if(id == 0){
      return await axios.post(`${path}`,data)
    }else{
      return await axios.post(`${path}`, {id, jsonData, description, name})
    }
  },
  findGameTemplateById: async (templateId) => {
    return await axios.get(`${path}/${templateId}`)
  },
  deleteGameTemplateById: async (templateId) => {
    return await axios.delete(`${path}/${templateId}`)
  },
})
